export type RoleScopeType = "GLOBAL" | "COUNTRY" | "OUTLET";

export interface RoleSummary {
  id: number;
  code: string;
  name: string;
  scope_type: RoleScopeType;
  multi_country: boolean;
  is_system: boolean;
  active: boolean;
  user_count: number;
  permission_count: number;
}

export interface RoleDetail {
  id: number;
  code: string;
  name: string;
  description: string | null;
  scope_type: RoleScopeType;
  multi_country: boolean;
  is_system: boolean;
  active: boolean;
  permission_ids: number[];
  permission_codes: string[];
  assignable_role_ids: number[];
}

export interface PermissionItem {
  id: number;
  code: string;
  module: string;
  action: string;
  menu_path: string | null;
  sort_order: number;
  name: string;
  description: string | null;
}

export interface PermissionGroup {
  module: string;
  menu_path: string | null;
  permissions: PermissionItem[];
}

export interface RoleUser {
  id: number;
  full_name: string;
  email: string;
  phone_number: string | null;
  created_date: string;
}

export interface RoleAuditLog {
  id: number;
  actor_admin_id: number | null;
  action: string;
  role_id: number | null;
  target_admin_id: number | null;
  before_value: string | null;
  after_value: string | null;
  created_date: string;
}

export const SCOPE_LABELS: Record<RoleScopeType, string> = {
  GLOBAL: "Global (all data)",
  COUNTRY: "Country (selected countries)",
  OUTLET: "Salon group (assigned salons)",
};
